<template>
  <div class="page-permessi">

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri"
        @click="() => { filtriActive ? closeFiltri() : openFiltri() }">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
    </div>

    <div class="WEB-body col-24 no-padding">

      <!-- Filtri -->
      <div class="WEB-filtri" v-show="filtriActive">
        <div class="WEB-filtri-content">
          <div class="row">
            <!--<div class="WEB-filtri-title col-24">
              {{$t('filtri.selFiltri')}}
            </div>-->
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.anno') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.anno" class="WEB-select" value-key="tipoAuto">
                <el-option v-for="item in select_anno" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.mese') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.mese" class="WEB-select" value-key="tipoAuto">
                <el-option v-for="item in select_mese" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.localita') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.localita" class="WEB-select" value-key="localita">
                <el-option v-for="item in select_localita" :key="item.localita" :label="item.descrizione"
                  :value="item.localita">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="filtri-footer row">
          <div class="col-12 filtri-button-sx">
            <el-button class="WEB-button WEB-button-alternative" @click="svuotaCampi()">
              {{ $t('btn.svuotaCampi') }}
            </el-button>
          </div>
          <div class="col-12 filtri-button-dx">
            <el-button class="WEB-button WEB-button-primary central" @click="cerca()">
              {{ $t('btn.cerca') }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="mask-div" v-show="filtriActive" @click="closeFiltri" />
      <!-- END Filtri -->


      <el-table :data="items" highlight-current-row width="100%" v-loading="loading" class="custom-table table-ferie"
        :height="100 % - 56 - 60 - 83">

        <el-table-column prop="desTipoAuto" header-align="center" align="center" :label="($t('ricAuto.tipoAuto'))" min-width="100">
        </el-table-column>
        <el-table-column prop="desLocalita" header-align="center" align="center" :label="($t('ricAuto.localita'))" min-width="200">
        </el-table-column>
        <el-table-column prop="puntoRicarica" header-align="center" align="center" :label="($t('ricAuto.puntoRicarica'))" min-width="200">
        </el-table-column>
        <el-table-column prop="indirizzo" header-align="center" align="center" :label="($t('ricAuto.indirizzo'))" min-width="200">
        </el-table-column>
        <el-table-column prop="desConnettore" header-align="center" align="center" :label="($t('ricAuto.connettore'))" >
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('ricAuto.data'))" width="140">
          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ formatDate(scope.row.data)  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('ricAuto.orario'))" width="140">
          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.oreInizio + ' - ' + scope.row.oreFine }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" width="50">
          <template slot-scope="scope">
            <div class="actions">
              <icon class="pointer" name="riv-delete2" scale="1.1"  v-if="scope.row.operazioni === 'DELETE'"
                @click.native="() => {
                  deleteRichiesta(scope.row)
                }"></icon>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>    

  </div>
</template>

<script>
import moment from 'moment'
import { bus } from '../Bus.js'

export default {
  name: 'ElencoRicAuto',
  props: ['tableHeight'],
  data() {
    return {// filtri
      filtriActive: false,
      filtro: {
        data: '',
        tipoAuto: '',
        localita: '',
        oreInizio: '',
        oreFine: ''
      },
      country: "",
      loading: false,
      select_anno: [],
      select_mese: [],
      select_localita: [],
      select_auto: [],
      loading_save: false,
      items: []
    }
  },
  filters: {
    getCreationDate: function (id) {
      if (id === undefined || id === '' || id.length < 10) {
        return ''
      } else {
        return moment(id, "YYYY-MM-DD").format("DD/MM/YYYY")
      }
    }
  },
  activated: async function () {
    this.initialize()
    this.country = this.$store.state.country

    this.select_anno = []
    const currentYear = new Date().getFullYear()

    for (let y = currentYear - 2; y <= currentYear + 1; y++) {
      this.select_anno.push({
        codice: y,
        descrizione: String(y)
      })
    }

    // default anno corrente
    this.filtro.anno = currentYear

    this.buildSelectMese()
    /*this.select_mese = []
    for (let i = 1; i <= 12; i++) {
      const mm = String(i).padStart(2, '0')
      this.select_mese.push({
        codice: mm,
        descrizione: this.$t(`months.${mm}`)   // 👈 tradotto
      })
    }*/

    // default mese corrente (sempre due cifre)
    const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0')
    this.filtro.mese = currentMonth

    //await this.getAuto()
    await this.getLocalita()
    this.ricerca()
    //this.getCountries()
  },
  deactivated: function () {
    this.country = ""
    this.filtriActive = false
    this.loading = false
    let filtro = {
      data: '',
      tipoAuto: '',
      localita: '',
      oreInizio: '',
      oreFine: ''
    }
    this.$set(this, 'filtro', filtro)
    this.$set(this, 'select_localita', [])
    this.$set(this, 'select_auto', [])
    this.$set(this, 'items', [])
    // 👇 cleanup per evitare listener doppi
  bus.$off('changeLanguage', this.onChangeLanguage)
  },
  methods: {
    initialize: function () {
      // registro il listener una sola volta
      bus.$off('changeLanguage', this.onChangeLanguage) // prevengo duplicati
      bus.$on('changeLanguage', this.onChangeLanguage)
      /*this.$nextTick(() => {
        bus.$on('changeLanguage', () => {
          this.$nextTick(() => {
            console.log('ElencoRicAuto: changeLanguage')
            this.buildSelectMese() // 👈 ricarica mesi tradotti
          })
        })
        console.log('ElencoRicAuto: changeLanguage listener registrato')
      })*/
    },
    onChangeLanguage() {
      console.log('ElencoRicAuto: changeLanguage')
      this.buildSelectMese()
    },
    buildSelectMese() {
      this.select_mese = []
      for (let i = 1; i <= 12; i++) {
        const mm = String(i).padStart(2, '0')
        this.select_mese.push({
          codice: mm,
          descrizione: this.$t(`months.${mm}`)
        })
      }
    },
    formatDate: function(date) {
      return date !== '' ? moment(date, "YYYYMMDD").format("DD/MM/YYYY") : ''
    },
    // GESTIONE FILTRI
    openFiltri: function () {
      this.filtriActive = true
    },
    closeFiltri: function () {
      this.filtriActive = false
    },
    svuotaCampi: function () {
      //this.$set(this.filtro, 'anno', '')
      //this.$set(this.filtro, 'mese', '')
      this.$set(this.filtro, 'localita', '')
    },
    cerca: function () {
      this.filtriActive = false
      this.ricerca()
    },
    async getAuto() {
      this.select_auto = []
      const response = await this.$http.get("postazioniricaricaauto/" + this.country + '/tipiauto', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          data: this.filtro.data
        }
      })
      if (response.body.rc === 0) {
        this.select_auto = response.body.data
        this.filtro.tipoAuto = this.select_auto[0].tipoAuto
      }
    },
    async getLocalita() {
      this.select_localita = []
      const response = await this.$http.get("postazioniricaricaauto/" + this.country + '/localita', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          data: this.filtro.data,
          tipoAuto: this.filtro.tipoAuto
        }
      })
      if (response.body.rc === 0) {
        this.select_localita = response.body.data
        this.filtro.localita = this.select_localita[0].localita
      }
    },
    async ricerca() {
      this.loading = true
      this.$set(this, 'items', [])
      try {
        const response = await this.$http.get(
          'postazioniricaricaauto/' + this.country + '/prenotazioni',
          {
            params: {
              anno: this.filtro.anno,
              mese: this.filtro.mese,
              localita: this.filtro.localita
            }
          }
        )

        if (response.body.rc === 0) {
          this.$set(this, 'items', response.body.data)
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
          this.$set(this, 'items', [])
        }
      } catch (err) {
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: process.env.duration
        })
        this.$set(this, 'items', [])
      } finally {
        this.loading = false
      }
    },
    async deleteRichiesta(row) {

      await this.$confirm(
        this.$t('ricAuto.delMsg'),
        this.$t('ricAuto.delTitle'),
        {
          confirmButtonText: this.$t('btn.conferma'),
          cancelButtonText:  this.$t('btn.annulla'),
          type: 'warning'
        }
      )

      this.loading_save = true

      let payload = {
        prenotazioni: [{
          data: row.data,
          puntoRicarica: row.puntoRicarica,
          tipoAuto: row.tipoAuto,
          oreInizio: row.oreInizio,
          oreFine: row.oreFine
        }]
      }

      try {
        console.log("payload inviato", JSON.stringify(payload))

        const response = await this.$http.post(
          "postazioniricaricaauto/" + this.country + '/dltprenotazioni',
          payload,
          {
            params: {
              codLang: sessionStorage.getItem('codLang')
            }
          }
        )

        if (response.body.rc === 0) {
          this.ricerca()
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      } catch (err) {
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: process.env.duration
        })
      } finally {
        this.loading_save = false
      }
    },
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

.page-permessi {
  .WEB-actions {
    .prec {
      padding-right: 20px;
      float: none;
    }

    .succ {
      padding-right: 20px;
      float: none;
    }

    .el-date-editor {
      .el-input__inner:hover {
        cursor: pointer;
      }

      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 25px;
        padding-right: 10px;
        width: 150px;
        text-align: center;
      }

      .el-input__prefix {
        left: -5px;

        .el-input__icon {
          line-height: 22px;
        }
      }
    }

    .el-select {

      //margin-left: 20px;
      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 0px;
        padding-right: 10px;
      }

      .el-input__suffix {
        right: -5px;
      }
    }

    .el-checkbox {
      .el-checkbox__inner {
        border-radius: 0px;
      }

      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }

    .header-label {
      .set-font(@size: 14px; @weight: bold);
    }

    .header-value {
      .set-font(@size: 14px; @color: #666);
    }

    .action {
      float: right;
      text-align: right;
    }
  }

  .table-ferie {
    margin-top: 20px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px) - MArgin-top (10px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px - 10px);
  }
}

.autorizzazioni-ferie {
  height: 100%;
  padding: 0;

  .riepilogo {
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;

    .elemento {
      line-height: 40px;

      .titolo {
        height: 60px;
        line-height: 30px;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
      }

      .my-label {
        text-align: left;
        .set-font(@size: 14px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
      }

      .my-value {
        text-align: right;
        .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');

        .el-select {
          .el-input__inner {
            height: 22px;
            line-height: 22px;
            border: 0px;
            border-bottom: 1px solid #e7e7e7;
            border-radius: 0px;
            padding-left: 0px;
            padding-right: 10px;
          }

          .el-input__suffix {
            right: -5px;
          }
        }

        .anno {
          .el-select {
            .el-input__inner {
              width: 55px;
            }
          }
        }

        .stato {
          .el-select {
            width: 90%;
          }
        }
      }
    }
  }

  .elenco {
    height: calc(100vh - 56px - 66px);
    padding: 10px;

    .box {
      padding-top: 10px;
      overflow: auto;
      background-color: #f2f2f2;
      border-radius: 5px;

      .action {
        height: 80px;

        .filter {
          margin-top: 10px;
          text-align: left;
          line-height: 40px;

          .iconArrow {
            cursor: pointer;
            display: inline-block;
            position: relative;
            top: -2px;
            .set-font(@color: @oroRiva, @weight: bold, @family: 'os-regular');
          }

          span {
            .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
          }
        }
      }

      .el-table {
        background-color: #f2f2f2;

        .el-table__header {
          thead {
            tr {
              background-color: #f2f2f2;
            }

            th {
              background-color: #f2f2f2;
            }
          }
        }
      }

      .el-table__body {
        .el-table__row {
          background-color: #f2f2f2;
        }

      }
    }

    .table-ferie {
      height: calc(100vh - 56px - 60px - 82px);
    }
  }

  .note {
    padding: 10px 10px 10px 0px;

    .box {
      border: 1px solid #f2f2f2;

      .note-dip,
      .note-resp {
        .my-label {
          text-align: left;
          margin: 10px;
          border-bottom: 2px solid @greenRiva;

          padding-bottom: 5px;
          .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
        }

        .my-value {
          text-align: left;
          margin: 10px;
          .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');
        }

        height: 150px;
      }
    }

  }

}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.icon-bordered {
  border: 1px solid #ccc;  /* bordo grigio */
  //padding: 4px;            /* spazio interno */
  //border-radius: 4px;      /* angoli arrotondati */
  //display: inline-block;    /* necessario per padding e bordo */
  cursor: pointer;          /* cambia cursore al passaggio */
  transition: all 0.2s;    /* effetto hover morbido */
}

.riva-header-checkbox {
  .el-checkbox {
    .el-checkbox__input {
      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color:  @greenRiva;
        }
      }
      &.is-focus {
        .el-checkbox__inner {
          border-color:  #DCDFE6;
        }
      }
      .el-checkbox__inner:hover {
        border-color:  @greenRiva;
      }
    }
    .el-checkbox__label {
      font-size: 14px;
      font-family: 'os-regular';
      color: #606266;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TorretteRicAuto/ElencoRicAuto.vue